import { __ } from '@wordpress/i18n';
import { ReactComponent as Popup } from '../../../assets/popup-icons/popup.svg';
import { ReactComponent as FullPage } from '../../../assets/popup-icons/fullpage.svg';
import { ReactComponent as BottomBar } from '../../../assets/popup-icons/bottombar.svg';
import { ReactComponent as TopBar } from '../../../assets/popup-icons/topbar.svg';
import { ReactComponent as OffCanvas } from '../../../assets/popup-icons/offcanvas.svg';
import { ReactComponent as SlideIn } from '../../../assets/popup-icons/slidein.svg';

const variations = [
	{
		name: 'simple',
		title: __( 'Default' ),
		description: __( 'Default popup' ),
		icon: Popup,
		attributes: {
			align: 'center center',
			fullPage: false,
			fullWidth: false,
			className: 'is-style-default',
		},
		innerBlocks: [
			[ 'popper/button' ],
			[
				'popper/body',
				{
					backgroundColor: 'white',
					style: {
						spacing: {
							padding: {
								top: 'var:preset|spacing|20',
								bottom: 'var:preset|spacing|20',
								left: 'var:preset|spacing|20',
								right: 'var:preset|spacing|20',
							},
						},
					},
				},
				[
					[
						'core/heading',
						{
							content: 'My first popup',
						},
					],
					[
						'core/paragraph',
						{
							content: 'Add your favorite blocks',
						},
					],
				],
			],
		],
		scope: [ 'block' ],
	},
	{
		name: 'slide-in',
		title: __( 'Slide In' ),
		description: __( 'Slide in popup' ),
		icon: SlideIn,
		attributes: {
			align: 'bottom left',
			fullPage: false,
			fullWidth: false,
			className: 'is-style-default',
		},
		innerBlocks: [
			[ 'popper/button' ],
			[
				'popper/body',
				{
					backgroundColor: 'white',
					style: {
						spacing: {
							padding: {
								top: 'var:preset|spacing|20',
								bottom: 'var:preset|spacing|20',
								left: 'var:preset|spacing|20',
								right: 'var:preset|spacing|20',
							},
						},
					},
				},
				[
					[
						'core/heading',
						{
							content: 'My first popup',
						},
					],
					[
						'core/paragraph',
						{
							content: 'Add your favorite blocks',
						},
					],
				],
			],
		],
		scope: [ 'block' ],
	},
	{
		name: 'off-canvas',
		title: __( 'Off canvas' ),
		description: __( 'Off canvas' ),
		icon: OffCanvas,
		attributes: {
			align: undefined,
			className: 'is-style-off-canvas',
			backgroundColor: 'white',
		},
		innerBlocks: [
			[ 'popper/button' ],
			[
				'popper/body',
				{
					backgroundColor: 'white',
					style: {
						spacing: {
							padding: {
								top: 'var:preset|spacing|20',
								bottom: 'var:preset|spacing|20',
								left: 'var:preset|spacing|20',
								right: 'var:preset|spacing|20',
							},
						},
					},
				},
				[
					[
						'core/heading',
						{
							content: 'My first popup',
						},
					],
					[
						'core/paragraph',
						{
							content: 'Add your favorite blocks',
						},
					],
				],
			],
		],
		scope: [ 'block' ],
	},
	{
		name: 'top-bar',
		title: __( 'Top bar' ),
		description: __( 'Top Bar' ),
		icon: TopBar,
		attributes: {
			align: undefined,
			className: 'is-style-top-bar',
			backgroundColor: 'white',
		},
		innerBlocks: [
			[ 'popper/button' ],
			[
				'popper/body',
				{
					backgroundColor: 'white',
					style: {
						spacing: {
							padding: {
								top: 'var:preset|spacing|20',
								bottom: 'var:preset|spacing|20',
								left: 'var:preset|spacing|20',
								right: 'var:preset|spacing|20',
							},
						},
					},
				},
				[
					[
						'core/heading',
						{
							content: 'My first popup',
						},
					],
					[
						'core/paragraph',
						{
							content: 'Add your favorite blocks',
						},
					],
				],
			],
		],
		scope: [ 'block' ],
	},
	{
		name: 'bottom-bar',
		title: __( 'Bottom bar' ),
		description: __( 'Bottom Bar' ),
		icon: BottomBar,
		attributes: {
			align: undefined,
			className: 'is-style-bottom-bar',
			backgroundColor: 'white',
		},
		innerBlocks: [
			[ 'popper/button' ],
			[
				'popper/body',
				{
					backgroundColor: 'white',
					style: {
						spacing: {
							padding: {
								top: 'var:preset|spacing|20',
								bottom: 'var:preset|spacing|20',
								left: 'var:preset|spacing|20',
								right: 'var:preset|spacing|20',
							},
						},
					},
				},
				[
					[
						'core/heading',
						{
							content: 'My first popup',
						},
					],
					[
						'core/paragraph',
						{
							content: 'Add your favorite blocks',
						},
					],
				],
			],
		],
		scope: [ 'block' ],
	},
	{
		name: 'full-page',
		title: __( 'Full Page' ),
		description: __( 'Full Page' ),
		icon: FullPage,
		attributes: {
			align: undefined,
			fullPage: true,
			fullWidth: false,
			className: 'is-style-full-page',
			backgroundColor: 'white',
		},
		innerBlocks: [
			[ 'popper/button' ],
			[
				'popper/body',
				{
					backgroundColor: 'white',
					style: {
						spacing: {
							padding: {
								top: 'var:preset|spacing|20',
								bottom: 'var:preset|spacing|20',
								left: 'var:preset|spacing|20',
								right: 'var:preset|spacing|20',
							},
						},
					},
				},
				[
					[
						'core/heading',
						{
							content: 'My first popup',
						},
					],
					[
						'core/paragraph',
						{
							content: 'Add your favorite blocks',
						},
					],
				],
			],
		],
		scope: [ 'block' ],
	},
];

export default variations;
